import { enableProdMode, LOCALE_ID, DEFAULT_CURRENCY_CODE, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { UnespCoreModule } from '@unesp/core';
import {APP_ROUTES} from './app/app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import {CommonModule, registerLocaleData} from '@angular/common';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { menu } from './app/menu';
import 'moment/locale/pt.js';
import localePt from '@angular/common/locales/pt';
import {provideRouter} from "@angular/router";

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localePt);

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(CommonModule, BrowserModule, UnespCoreModule),
        { provide: 'environment', useValue: environment },
        { provide: 'menu', useValue: menu },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
        provideEnvironmentNgxMask(),
        provideAnimations(),
        provideRouter(APP_ROUTES)
    ]
})
  .catch(err => console.error(err));
